import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    style: _normalizeStyle({ backgroundImage: `url(${_ctx.article.img})` })
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.article.title), 1)
  ], 4))
}